import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import { initialRIBOForm1State } from "./RIBOForms.types";
import { RIBOFormsActions } from ".";
import { CLEAR_RIBO_FORMS_STATE, FETCH_RIBO_FORMS_FAILURE, FETCH_RIBO_FORMS_LIST_FAILURE, FETCH_RIBO_FORMS_LIST_PROGRESS, FETCH_RIBO_FORMS_LIST_SUCCESS, FETCH_RIBO_FORMS_PROGRESS, FETCH_RIBO_FORMS_SUCCESS } from "./RIBOFormsActions";

export const RIBOFormsReducer = (
  state: IStoreState["accounting"]["riboForms"] = initialRIBOForm1State,
  action: RIBOFormsActions
) => {
  switch (action.type) {
    case FETCH_RIBO_FORMS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_RIBO_FORMS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.dataLoading = LoadState.Loaded;
        draftState.data = data;
      });
      return newState;
    }

    case FETCH_RIBO_FORMS_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.error = errorMessage;
      });
      return newState;
    }

    case FETCH_RIBO_FORMS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_RIBO_FORMS_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
      });
      return newState;
    }

    case FETCH_RIBO_FORMS_LIST_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.error = errorMessage;
      });
      return newState;
    }

    case CLEAR_RIBO_FORMS_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.NotLoaded;
        draftState.data = initialRIBOForm1State.data;
        draftState.error = null;
      });
      return newState;
    }

    default:
      return state;
  }
};
